import { isEmpty } from 'lodash'
import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import jwt_decode from "jwt-decode";
import { useSelector } from 'react-redux';
import NavItem from '../nav';
import { ACCESS_LEVEL } from '../constant/constant';

function ProtectedRoute({access_level}) {
    const location = useLocation();
    const currentPath = location.pathname;
    const accessCookies = useSelector(state => state.loginSlice);

    if (isEmpty(accessCookies.token)) {
        return <Navigate to={'/login'} />;
    }

    const user = jwt_decode(accessCookies.token);

    // ADMIN sees all routes
    if (user.accessLevel >= ACCESS_LEVEL.ADMIN) {
        return <Outlet />;
    }

    const navMeta = NavItem.find((item) => item.path === currentPath);

    // No blanket "access_level <= yours" pass below admin -- Access Module
    // (permissions) is the sole, exhaustive source of truth for what a
    // sub-admin/cashier account can reach, matching checkNav in Header.js.
    const findModule = Array.isArray(user.accessModule) && user.accessModule.some(item =>
        item?.module &&
        item.module.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ') === navMeta?.title
    );

    return findModule ? <Outlet /> : <Navigate to={-1} />;
}

export default ProtectedRoute